/**
 * Shared visual constants for BGP visualizations.
 */

/**
 * SVG path for a 10×10 cross-hatch pattern tile (both diagonals).
 * Includes edge-overflow segments to prevent seam gaps at tile boundaries.
 */
export const CROSSHATCH_PATH = 'M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9 M 0 0 L 10 10 M -1 9 L 1 11 M 9 -1 L 11 1';

export const CROSSHATCH_SIZE = 10;
